import { render } from "./ContributorSectionFiscalAddress.vue?vue&type=template&id=667406ef&scoped=true"
import script from "./ContributorSectionFiscalAddress.vue?vue&type=script&lang=js"
export * from "./ContributorSectionFiscalAddress.vue?vue&type=script&lang=js"

import "./ContributorSectionFiscalAddress.vue?vue&type=style&index=0&id=667406ef&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667406ef"]])

export default __exports__